/* Moved from sections/hlth-recipes.liquid so browsers cache it (speed audit item 6, 16 Oct 2026); loaded async where the
   inline script was. */
(function () {
  function run(SID) {
      (function() {
        const id = SID;
        const track = document.querySelector('.hlth-recipes-track-' + id);
        if (!track) return;

        const nav = document.querySelector('.hlth-recipes-nav-' + id);
        const dots = document.querySelectorAll('.hlth-recipes-dot-' + id);

        /* Arrow navigation */
        if (nav) {
          nav.addEventListener('click', function(e) {
            const btn = e.target.closest('button');
            if (!btn) return;
            const card = track.querySelector('.hlth-recipe-card-' + id);
            if (!card) return;
            const gap = parseInt(getComputedStyle(track).gap) || 24;
            const scrollAmount = card.offsetWidth + gap;
            const dir = btn.dataset.dir === 'prev' ? -1 : 1;
            track.scrollBy({ left: dir * scrollAmount, behavior: 'smooth' });
          });
        }

        /* Dot sync on scroll */
        if (dots.length > 0) {
          let ticking = false;
          track.addEventListener('scroll', function() {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(function() {
              const cards = track.querySelectorAll('.hlth-recipe-card-' + id);
              const trackLeft = track.scrollLeft;
              const trackPad = parseInt(getComputedStyle(track).paddingLeft) || 0;
              let closest = 0;
              let minDist = Infinity;
              cards.forEach(function(card, i) {
                const dist = Math.abs(card.offsetLeft - trackPad - trackLeft);
                if (dist < minDist) { minDist = dist; closest = i; }
              });
              dots.forEach(function(dot, i) {
                dot.classList.toggle('is-active', i === closest);
              });
              ticking = false;
            });
          });

          /* Dot click */
          dots.forEach(function(dot) {
            dot.addEventListener('click', function() {
              const idx = parseInt(dot.dataset.index);
              const cards = track.querySelectorAll('.hlth-recipe-card-' + id);
              if (cards[idx]) {
                cards[idx].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
              }
            });
          });
        }
      })();
  }
  function scan(scope) {
    var list = [];
    if (scope.classList && scope.classList.contains('hlth-s--hlth-recipes')) list.push(scope);
    scope.querySelectorAll('.hlth-s--hlth-recipes').forEach(function (w) { list.push(w); });
    list.forEach(function (w) {
      if (w.__hlthJs_hlth_recipes) return;
      w.__hlthJs_hlth_recipes = true;
      run(w.id.replace(/^shopify-section-/, ''));
    });
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
